export default __webpack_public_path__ + "static/media/sbj-chemistry.96a5456b.svg";